import { BrowserRouter } from "react-router-dom";

//
import Router from "./router";
import GlobalStyles from "./assets/styles/global";
import histrory from "./router/histrory";
import ContextProvider from "./services/context/reducer";
import Toast from "./components/toast";

function App() {
  return (
    <BrowserRouter histrory={histrory}>
      <ContextProvider>
        <Toast />
        <GlobalStyles />
        <Router />
      </ContextProvider>
    </BrowserRouter>
  );
}

export default App;
